import axios from 'axios'
import qs from 'qs'
import md5 from 'md5'
import getLinkString from '@/util/sign'
import store from 'store'

let $vm
const browser = (() => {
  let ua = navigator.userAgent.toLowerCase()

  let names = {
    chrome: 'Chrome',
    safari: 'Safari',
    opera: 'Opera',
    firefox: 'FireFox',
    msie: 'IE'
  }

  let chrome = /chrome/i.test(ua)
  let safari = !chrome && /safari/.test(ua)
  let opera = /opera/.test(ua)
  let firefox = /firefox/.test(ua)
  let msie = !opera && !firefox && /msie|rv:/.test(ua)
  let version = (ua.match(/.+(?:rv|it|ra|ie)[/: ]([\d.]+)/) || [])[1]

  let engine = {
    chrome,
    safari,
    opera,
    firefox,
    msie
  }

  for (let k in engine) {
    if (engine[k]) {
      engine.name = names[k]
      break
    }
  }

  engine.isMobile = /mobile/.test(ua)
  engine.name = engine.name || 'unknown'
  engine.version = version || 0

  return engine
})()
// 对返回的数据进行处理
const resolveJSON = (json, done = () => {}, fail = () => {}) => {
  let {code, msg, data} = json
  data = data || {}
  let info = data.info
  let page = data.page

  if (code === '0000') {
    done(info, page, json)
  } else if (code === '1001') {
    // 签名认证失败， 清除token
    window.app.$router.replace('/')
    return window.app.$store.commit('clearToken')
  } else if (code === '1002') {
    // 未实名认证，跳转到实名认证页面
    return window.app.$router.replace('/authentication')
  } else {
    fail(msg, json)
  }
}
// 定义一个全局的ajax函数
const ajax = (options) => {
  options = Object.assign({
    url: '',
    data: {},
    done () {},
    fail (m) { $vm.$dialog(m) },
    always () {}
  }, options)
  options.data.time = Date.now()
  if (/[/]center[/]/.test(options.url)) {
    let mac = store.get('token')['mac']
    let sign = getLinkString(options.data, true) + mac
    options.data.sign = md5(sign)
  }
  return axios(Object.assign({
    url: options.url,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    params: {
      st: browser.name,
      sv: browser.version,
      pt: browser.name,
      sr: '0',
      vs: '1.0.0'
    },
    data: qs.stringify(options.data)
  }, options.settings))
    .then(response => response.data)
    .then(json => resolveJSON(json, options.done, options.fail))
    .catch((e) => {
      // console.log(e)
    })
}

const shuffle = (collection) => {
  let i = collection.length
  while (i) {
    let j = Math.floor(Math.random() * i--)
    let t = collection[i]
    collection[i] = collection[j]
    collection[j] = t
  }
  return collection
}

export default (Vue) => {
  Vue.md5 = md5
  Vue.shuffle = shuffle
  Vue.browser = browser
  Vue.http = ajax

  Vue.prototype.$md5 = md5
  Vue.prototype.$shuffle = shuffle
  Vue.prototype.$browser = browser
  Vue.prototype.$http = ajax

  Vue.mixin({
    created () {
      if (!$vm) {
        $vm = this
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/ajax.js